export default "__VITE_ASSET__XbW$DhX2__"